import { render } from "./HomePage.vue?vue&type=template&id=49be0640"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=49be0640&lang=css"
script.render = render

export default script